/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_ReadyInputs */

const en_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to book?`)
};

const es_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Listo para reservar?`)
};

const de_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit zur Buchung?`)
};

const zh_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备好预订了吗？`)
};

const ar_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستعد للحجز؟`)
};

const fr_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt à réserver ?`)
};

const vi_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẵn sàng đặt?`)
};

const sw_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je, uko tayari kuweka nafasi?`)
};

const th_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พร้อมจองหรือยัง?`)
};

const bs_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spremni za rezervaciju?`)
};

const ja_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予約の準備はできましたか？`)
};

const ko_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예약할 준비 되셨나요?`)
};

const pt_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto para agendar?`)
};

const it_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto a prenotare?`)
};

const sv_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo att boka?`)
};

const nl_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar om te boeken?`)
};

const da_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar til at bestille?`)
};

const nb_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar til å bestille?`)
};

const fi_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmiina varaukseen?`)
};

const pl_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowy do rezerwacji?`)
};

const ru_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готовы записаться?`)
};

const tr_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervasyona hazır mısınız?`)
};

const hi_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बुक करने के लिए तैयार?`)
};

const id_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap untuk memesan?`)
};

const ms_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedia untuk tempah?`)
};

const cs_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připraven na rezervaci?`)
};

const el_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έτοιμος για κράτηση;`)
};

const he_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוכנים להזמין?`)
};

const af_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gereed om te bespreek?`)
};

const hu_lessons_ready = /** @type {(inputs: Lessons_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Készen állsz a foglalásra?`)
};

/**
* | output |
* | --- |
* | "Ready to book?" |
*
* @param {Lessons_ReadyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_ready = /** @type {((inputs?: Lessons_ReadyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_ReadyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_ready(inputs)
	if (locale === "de") return de_lessons_ready(inputs)
	if (locale === "zh") return zh_lessons_ready(inputs)
	if (locale === "ar") return ar_lessons_ready(inputs)
	if (locale === "fr") return fr_lessons_ready(inputs)
	if (locale === "vi") return vi_lessons_ready(inputs)
	if (locale === "sw") return sw_lessons_ready(inputs)
	if (locale === "th") return th_lessons_ready(inputs)
	if (locale === "bs") return bs_lessons_ready(inputs)
	if (locale === "ja") return ja_lessons_ready(inputs)
	if (locale === "ko") return ko_lessons_ready(inputs)
	if (locale === "pt") return pt_lessons_ready(inputs)
	if (locale === "it") return it_lessons_ready(inputs)
	if (locale === "sv") return sv_lessons_ready(inputs)
	if (locale === "nl") return nl_lessons_ready(inputs)
	if (locale === "da") return da_lessons_ready(inputs)
	if (locale === "nb") return nb_lessons_ready(inputs)
	if (locale === "fi") return fi_lessons_ready(inputs)
	if (locale === "pl") return pl_lessons_ready(inputs)
	if (locale === "ru") return ru_lessons_ready(inputs)
	if (locale === "tr") return tr_lessons_ready(inputs)
	if (locale === "hi") return hi_lessons_ready(inputs)
	if (locale === "id") return id_lessons_ready(inputs)
	if (locale === "ms") return ms_lessons_ready(inputs)
	if (locale === "cs") return cs_lessons_ready(inputs)
	if (locale === "el") return el_lessons_ready(inputs)
	if (locale === "he") return he_lessons_ready(inputs)
	if (locale === "af") return af_lessons_ready(inputs)
	if (locale === "hu") return hu_lessons_ready(inputs)
	return en_lessons_ready(inputs)
});